import { ChronoUnit, LocalTime } from '@js-joda/core';
import { noop } from 'lodash';

import { AppointmentFormController } from '../AppointmentForm.types';
import { ReceptionServiceTableBean } from '../../../../../receptionService/extensions/calendar/appointment/interactiveTable/ReceptionServiceInteractiveTable.types';
import receptionService from '../../../../../receptionService';

const ESTIMATED_DURATION_MIN_VALUE = 5;

export const syncEstimatedDurationValue = (
   setValue: AppointmentFormController['setValue'],
   getValue: AppointmentFormController['getValue']
): void => {
   const startTime = getValue('startTime');
   const endTime = getValue('endTime');
   const date = getValue('date');
   const startDate = date?.atTime(startTime);

   if (endTime.equals(LocalTime.MIDNIGHT)) {
      return setValue('estimatedDuration', startDate?.until(date?.plusDays(1).atStartOfDay(), ChronoUnit.MINUTES));
   }

   return setValue('estimatedDuration', startTime.until(endTime, ChronoUnit.MINUTES));
};

export const syncEndTime = (
   setValue: AppointmentFormController['setValue'],
   getValue: AppointmentFormController['getValue'],
   receptionServiceValue: ReceptionServiceTableBean[]
): void => {
   const startTime = getValue('startTime');
   const endTime = getValue('endTime');
   const estimatedDuration = getValue('estimatedDuration');
   const date = getValue('date');
   const startDate = date?.atTime(startTime);

   const remainingMinutesInDay = startDate?.until(date?.plusDays(1).atStartOfDay(), ChronoUnit.MINUTES);
   const calculatedTotalEstimatedDuration = receptionService.getCalculatedTotalEstimatedDuration(receptionServiceValue);

   if (remainingMinutesInDay <= estimatedDuration) {
      setValue('estimatedDuration', remainingMinutesInDay);
      return setValue('endTime', LocalTime.MIDNIGHT);
   }

   if (
      receptionServiceValue.length &&
      remainingMinutesInDay <= calculatedTotalEstimatedDuration &&
      endTime.equals(LocalTime.MIDNIGHT)
   ) {
      return setValue('estimatedDuration', calculatedTotalEstimatedDuration);
   }

   return setValue('endTime', startTime.plusMinutes(estimatedDuration));
};

export const syncStartTime = (
   setValue: AppointmentFormController['setValue'],
   getValue: AppointmentFormController['getValue']
): void => {
   const estimatedDuration = getValue('estimatedDuration');
   const startTime = getValue('startTime');
   const endTime = getValue('endTime');

   const elapsedMinutesInDay = Math.abs(endTime.until(LocalTime.MIN, ChronoUnit.MINUTES));

   if (elapsedMinutesInDay !== 0 && elapsedMinutesInDay < estimatedDuration) {
      setValue('estimatedDuration', elapsedMinutesInDay);
      return setValue('startTime', LocalTime.MIN);
   }

   if (endTime.isBefore(startTime) && !LocalTime.MIDNIGHT.equals(endTime)) {
      return setValue('startTime', endTime.minusMinutes(estimatedDuration));
   }

   if (!startTime.until(endTime, ChronoUnit.MINUTES) && !LocalTime.MIDNIGHT.equals(endTime)) {
      return setValue('startTime', endTime.minusMinutes(ESTIMATED_DURATION_MIN_VALUE));
   }

   return noop();
};
